import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Badge from 'flarum/common/components/Badge';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import SocialButtonsModal from '../components/SocialButtonsModal';
import getFaviconUrl from '../helpers/getFaviconUrl';
export default function extendUserCard() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user.canViewSocialProfile()) {
      return;
    }
    const canEdit = user.canEditSocialProfile();
    const buttons = user.socialButtons();
    const buttonList = new ItemList();
    if (buttons.length) {
      buttons.forEach((button, index) => {
        if (button && button.title && button.icon && button.url) {
          let buttonStyle = {};
          let buttonClassName = classList({
            ["social-button ".concat(button.icon, "-").concat(index, " social-icon-").concat(index)]: true,
            'social-greyscale-button': button.icon === 'favicon-grey'
          });
          if (button.icon === 'favicon' || button.icon === 'favicon-grey') {
            if (app.forum.attribute('fof-socialprofile.allow_external_favicons')) {
              // Favicon buttons render the icon via a background image, so the
              // Badge's own icon element must be hidden (see forum.less).
              buttonClassName += ' social-favicon-button';
              buttonStyle = {
                backgroundImage: "url(\"".concat(getFaviconUrl(button.url), "\")"),
                backgroundSize: '60%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              };
            } else {
              buttonClassName += ' fas fa-globe';
            }
          }
          buttonList.add("social-icon-".concat(index), m("a", {
            href: button.url,
            target: "_blank",
            rel: "noreferrer noopener nofollow"
          }, Badge.component({
            className: classList({
              [buttonClassName]: true
            }),
            type: "social",
            icon: button.icon,
            label: button.title,
            style: buttonStyle
          })));
        }
      });
      if (canEdit) {
        buttonList.add('settings social-button', Badge.component({
          type: 'social social-settings',
          icon: 'fas fa-cog',
          label: app.translator.trans('fof-socialprofile.forum.edit.edit'),
          onclick: () => {
            app.modal.show(SocialButtonsModal, {
              user
            });
          }
        }), -1);
      }
    } else if (canEdit) {
      buttonList.add('settings social-button', Badge.component({
        type: 'social null-social-settings',
        icon: 'fas fa-plus',
        label: app.translator.trans('fof-socialprofile.forum.edit.add'),
        onclick: () => {
          app.modal.show(SocialButtonsModal, {
            user
          });
        }
      }), -1);
    }
    if (buttonList.toArray().length > 0) {
      items.add('fofsocialprofile', buttonList.toArray(), 20);
    }
  });
}
flarum.reg.add('fof-socialprofile', 'forum/extenders/extendUserCard', extendUserCard);